const ScoreBarTypes = {
    CROISSANT: 'croissant',
    NORMAL: 'normal',
    BAR_GRAPH: 'barGraph',
    STARS: 'stars',
    CUTOFF: 'cutOff',
    GAUGE: 'gauge'
};

export default ScoreBarTypes;
